import { IApplicationState } from '../../types/redux';

export function isFloorPlanOpened(state: IApplicationState) {
  return state.floorPlan.isOpened;
}
